<script>
import { Line } from "vue-chartjs"

export default {
    extends: Line,
    props: ["data_graph"],
    data() {
        return {
            color: [
                "#FC2525",
                "#05CBE1",
                "#44ff66",
                "#dbdb00",
                "#7e00d8",
                "#000c96",
                "#f46e00",
            ],
            color1: [
                "rgba(255, 0,0, 0.5)",
                "rgba(0, 231, 255, 0.9)",
                "rgba(207, 248, 188, 0.9)",
                "rgba(255, 251, 0, 0.9)",
                "rgba(200, 148, 250, 0.9)",
                "rgb(0, 62, 197, 0.9)",
                "rgba(250, 200, 135, 0.9)",
            ],
            color2: [
                "rgba(255, 0, 0, 0.25)",
                "rgba(0, 231, 255, 0.25)",
                "rgba(185, 250, 154, 0.25)",
                "rgba(255, 251, 0, 0.25)",
                "rgba(88, 16, 156, 0.25)",
                "rgb(0, 32, 100, 0.25)",
                "rgba(241, 154, 41, 0.25)",
            ],
            color3: "rgba(255, 0, 0, 0)",
        }
    },
    mounted() {
        // console.log(this.data_graph.datasets, "--data_graph")
        this.data_graph.datasets.map((r, i) => {
            r.borderColor = this.color[i]
            r.backgroundColor = this.$refs.canvas
                .getContext("2d")
                .createLinearGradient(0, 0, 0, 1050)
            r.backgroundColor.addColorStop(0, this.color1[i])
            r.backgroundColor.addColorStop(0.5, this.color2[i])
            r.backgroundColor.addColorStop(1, this.color3)
        })

        this.renderChart(this.data_graph, {
            responsive: true,
            maintainAspectRatio: false,
        })
    },
}
</script>
<style>
.colorxx {
    color: rgb(0, 32, 100);
}
</style>
